window.VjsUtility = (function(my){
    var self = my.Controller = {};

    self.extend = function(extendProperties){
        return window.VjsUtility.extend(self.Controller, extendProperties);
    }

    self.Controller = function() {};
    self.Controller.prototype = {
        /**
         *  @desc events object to be set when class is instantiated
         */
        events: {
            //example of click event
            //"click .some-class": "callThisCustomFunction"
        },
        //callThisCustomFunction: function(){}     -- add a function to be called when event triggered

        _construct: function() {
            this._setEvents();
        },
        _setEvents: function() {
            var s,
                events = this.events,
                that = this;
            for (var items in events) {
                s = items.split(" ");

                if (s[0] === "scroll") {
                    $(window).off(s[0]);
                    $(window).on(s[0], { items: events[items], that: this }, function(e) {
                        //Passing Context
                        var that = e.data.that;
                        that[e.data.items](e);
                    });
                } else {
                    //Remove the same event before adding another
                    $("body").off(s[0], s[1]);
                    $("body").on(s[0], s[1], { items: events[items], that: this }, function(e) {
                        //Passing Context
                        var that = e.data.that;
                        that[e.data.items](e);
                    });
                }
            }
        }
    };

    return my;
}(window.VjsUtility || {}));
